<div class="selector-ubicacion">
  <div class="selector-ubicacion__busqueda">
    <span class="material-icons">search</span>
    <input type="text" [(ngModel)]="busqueda" (keyup.enter)="buscar()" placeholder="Buscar dirección, colonia o lugar" aria-label="Buscar dirección" />
    <button type="button" class="selector-ubicacion__boton" [disabled]="buscando" (click)="buscar()">
      {{ buscando ? "Buscando…" : "Buscar" }}
    </button>
    <button type="button" class="selector-ubicacion__boton selector-ubicacion__boton--secundario" title="Usar mi ubicación actual" (click)="usarMiUbicacion()">
      <span class="material-icons">my_location</span>
    </button>
  </div>

  <ul class="selector-ubicacion__resultados" *ngIf="resultados.length">
    <li *ngFor="let resultado of resultados">
      <button type="button" (click)="irA(resultado)">
        <span class="material-icons">place</span>
        <span>{{ resultado.nombre }}</span>
      </button>
    </li>
  </ul>
  <p class="selector-ubicacion__aviso" *ngIf="aviso">{{ aviso }}</p>

  <div class="selector-ubicacion__mapa" #lienzo></div>

  <p class="selector-ubicacion__pie">
    <ng-container *ngIf="tienePunto">
      <span class="material-icons">place</span>
      {{ latitud | number: "1.5-5" }}, {{ longitud | number: "1.5-5" }} · Dé clic en otro punto para moverlo.
    </ng-container>
    <ng-container *ngIf="!tienePunto">Busque la dirección o dé clic en el mapa donde está el sitio.</ng-container>
  </p>
</div>
